<template>
  <div>
    <div
      class="c-button__dropdown__container__overlay"
      :class="{ 'c-button__dropdown__container__overlay__active': isActiveDropdown }"
      @click="hideDropdownContainer"
    ></div>

    <div class="c-button c-button_with-icon" :class="{ 'c-button_responsive': responsive !== undefined }">
      <div v-if="type !== 'dropdown'" class="c-button__wrapper" @click="click">
        <div v-if="type === 'with-icon'" class="c-button__icon">
          <c-icon :icon="icon" :color="iconColor" />
        </div>

        <div v-if="label" class="c-button__label">
          {{ label }}
        </div>
      </div>

      <div
        v-if="type === 'dropdown'"
        class="c-button__wrapper"
        :class="{ 'c-button__wrapper__active': isActiveDropdown }"
        @click="isActiveDropdown = !isActiveDropdown"
      >
        <div v-if="dropdownWithIcon" class="c-button__icon">
          <c-icon :icon="dropdownIcon" :color="dropdownIconColor" />
        </div>

        <div v-if="label" class="c-button__label__left">
          {{ label }}
        </div>

        <div v-if="type === 'dropdown'" class="c-button__icon__right">
          <c-icon :icon="icon" :color="iconColor" />
        </div>

        <div
          v-if="type === 'dropdown'"
          class="c-button__dropdown__container"
          :class="{
            'c-button__dropdown__container__active': isActiveDropdown,
            'c-button__dropdown__container__left': dropdown.position === 'left' || !dropdown.position,
            'c-button__dropdown__container__center': dropdown.position === 'center',
            'c-button__dropdown__container__right': dropdown.position === 'right',
          }"
        >
          <div class="c-button__dropdown__container__list">
            <a
              v-for="item in dropdown.items"
              :key="item.value"
              :href="item.link || 'javascript:void(0)'"
              class="c-button__dropdown__container__list__item"
              :class="item.class"
              :target="item.link && '_blank'"
              @click="!item.link && onItemClick(item)"
            >
              <c-icon v-if="item.icon" :icon="item.icon" :color="item.iconColor" />
              <div class="c-button__dropdown__container__list__item__label">
                <span v-html="item.label"></span>
                <template v-if="item.component">
                  <component :is="item.component"></component>
                </template>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/icon";

export default {
  name: "c-button2",

  components: {
    "c-icon": Icon,
  },

  props: [
    "icon",
    "dropdownWithIcon",
    "dropdownIcon",
    "dropdownIconColor",
    "iconColor",
    "type",
    "label",
    "responsive",
    "dropdown",
  ],

  data() {
    return {
      isActiveDropdown: false,
    };
  },

  methods: {
    click() {
      this.$emit("click");
    },
    onItemClick(item) {
      this.$emit(item.emit, item.value);
    },
    hideDropdownContainer() {
      this.isActiveDropdown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-button {
  &__wrapper {
    position: relative;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: 0.2s;
  }

  &_responsive {
    @media screen and (max-width: 700px) {
      .c-button__wrapper {
        width: 30px;
      }

      .c-button__label {
        display: none;
      }

      .c-button__icon {
        margin-left: -10px !important;
        display: inline-block;
      }
    }
  }

  &_with-icon {
    .c-button {
      &__wrapper {
        height: 30px;
        border: 1px solid $color-button-border;
        box-sizing: border-box;
        padding: 0 15px;
        border-radius: 15px;

        &:hover {
          border-color: $color-button-border-hover;
        }

        &:active {
          border-color: $color-button-border-clicked;
        }

        &__active {
          border-color: $color-button-border-clicked;
        }
      }

      &__icon {
        margin-left: -5px;
        width: 20px;
        height: 20px;
      }

      &__icon__right {
        margin-right: -5px;
        width: 20px;
        height: 20px;
        & .c-icon_arrow {
          margin-left: -6px;
        }
      }

      &__label {
        margin-left: 8px;

        font: {
          size: 12px;
          weight: 500;
        }
        &__left {
          margin-left: 5px;
          margin-right: 5px;

          font: {
            size: 12px;
            weight: 500;
          }
        }
      }
    }
  }

  &__dropdown__container {
    position: absolute;
    visibility: hidden;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    opacity: 0;
    z-index: 300;
    padding: 10px;
    max-width: 200px;
    min-width: 130px;
    background: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
    border-radius: 6px;
    top: 34px;

    &__left {
      right: 0 !important;
    }

    &__center {
      left: 50% !important;
      transform: translate(-50%, 0);
    }

    &__right {
      left: 0 !important;
    }

    &__active {
      opacity: 1;
      visibility: visible;
    }

    &__overlay {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: $z-index-overlay;
      visibility: hidden;
      opacity: 0;
      transition: 0.2s;

      &__active {
        visibility: visible;
        opacity: 1;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;

      &__item {
        display: flex;
        align-items: center;
        border-radius: 50px;
        padding: 0 15px;
        color: inherit;
        text-decoration: none;

        &:hover {
          background: #e1edff;
        }

        &.disabled {
          opacity: 0.4;
          cursor: not-allowed;
          pointer-events: none;
        }

        &__label {
          font: 400 15px Fira Sans;
          line-height: 190%;
        }
      }

      &__item > .c-icon {
        margin: 0 9px 0 0px !important;
      }

      ::v-deep svg {
        transform: translate(-50%, -50%) !important;
      }
    }
  }
}
</style>
